/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Motivation_Too_ShortInputs */

const en_validation_motivation_too_short = /** @type {(inputs: Validation_Motivation_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter at least 60 characters.`)
};

const de_validation_motivation_too_short = /** @type {(inputs: Validation_Motivation_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte mindestens 60 Zeichen eingeben.`)
};

/**
* | output |
* | --- |
* | "Please enter at least 60 characters." |
*
* @param {Validation_Motivation_Too_ShortInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const validation_motivation_too_short = /** @type {((inputs?: Validation_Motivation_Too_ShortInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Motivation_Too_ShortInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_validation_motivation_too_short(inputs)
	return en_validation_motivation_too_short(inputs)
});